import React, { memo } from 'react';
import {
  Box, TextField, FormControl, InputLabel, Select, MenuItem, Button
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { PointOfSale } from '@mui/icons-material';
import { SEARCH_COLUMNS } from '../constants';

interface SearchBarProps {
  searchTerm: string;
  searchColumn: string;
  onSearchTermChange: (value: string) => void;
  onSearchColumnChange: (value: string) => void;
  onMassReportsLock: () => void;
  onMassPOSLock: () => void;
  currentUserRole: string | null;
}

const SearchBar: React.FC<SearchBarProps> = memo(({
  searchTerm,
  searchColumn,
  onSearchTermChange,
  onSearchColumnChange,
  onMassReportsLock,
  onMassPOSLock,
  currentUserRole
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 2 }}>
      <TextField
        label="Поиск"
        variant="outlined"
        margin="normal"
        value={searchTerm}
        onChange={(e) => onSearchTermChange(e.target.value)}
        sx={{
          mb: 1,
          width: 'calc(100% - 340px)',
        }}
      />
      <FormControl sx={{ minWidth: 200, mt: 2 }}>
        <InputLabel>Поиск по</InputLabel>
        <Select
          value={searchColumn}
          onChange={(e) => onSearchColumnChange(e.target.value)}
          label="Поиск по"
        >
          {SEARCH_COLUMNS.map(column => (
            <MenuItem key={column.value} value={column.value}>
              {column.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {
        currentUserRole !== 'guide' && (
          <>
            <Button
              variant='contained'
              color='error'
              onDoubleClick={onMassReportsLock}
              disabled={currentUserRole !== 'admin'}
              sx={{ width: 150, mt: 2, mb: 1 }}
            >
              Отчеты <LockOutlinedIcon />
            </Button>
            <Button
              variant='contained'
              color='error'
              onDoubleClick={onMassPOSLock}
              disabled={currentUserRole !== 'admin'}
              sx={{ width: 150, mt: 2, mb: 1 }}
            >
              Касса <PointOfSale />
            </Button>
          </>
        )
      }
    </Box >
  );
});

SearchBar.displayName = 'SearchBar';

export default SearchBar;

